import 'react-app-polyfill/ie11';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './styles/main.scss';
import App from './App';
import reducer from './store/reducers/index';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import './fonts/MaisonNeue-Book.otf';
import './fonts/MaisonNeue-Demi.otf';

const store = createStore(reducer, applyMiddleware(thunk));

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('diku')
);
